// @flow
import React, { Component } from "react";
import Webcam from "react-webcam";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import { buttonStyles } from "../../global/components/StyledButtons";

class WebCamera extends Component<*> {
  webcam: *;
  setRef = (webcam: *) => {
    this.webcam = webcam;
  };

  capture = () => {
    const imageSrc = this.webcam.getScreenshot({ width: 2450, height: 1830 });
    this.props.captureCamera(imageSrc);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <Webcam
            audio={false}
            ref={this.setRef}
            screenshotFormat="image/png"
            screenshotQuality={1}
            style={{ width: "100%", height: "100%" }}
            onUserMediaError={this.props.setError}
          />
        </Grid>
        <Grid item xs={12}>
          <div className="form-right-btn-block">
            <Button
              color="primary"
              className={classes.linkBtn}
              onClick={this.props.cancelCamera}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="raised"
              type="submit"
              onClick={this.capture}
              className={classes.primaryBtn}
              style={{ width: "60%", margin: "5px 2%" }}
            >
              Capture Photo
            </Button>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(buttonStyles)(WebCamera);



// WEBPACK FOOTER //
// ./src/conference/component/WebCamera.js